import React, {Component} from 'react';
import {Navigate} from "react-router";

interface RedirectToSearchProps {
    navToSearch?: boolean;
}

class RedirectToSearch extends Component<RedirectToSearchProps> {

    render() {
        return (
            <div>
                {
                    this.props.navToSearch ? <Navigate to='/yards'/> : ''
                }
            </div>
        )
    }
}

export default RedirectToSearch;